module.exports = __webpack_public_path__ + "img/czleader12.a281e0f9.png";